import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Home from '../views/pedido/Home.vue'

Vue.use(VueRouter)

  const routes = [
  // Pedidos
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Syclus Pedidos - Home'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: 'Syclus Pedidos - Login'
    }
  },
  {
    path: '/pedidos/:id',
    name: 'Pedido',
    props: true,
    component: () => import('../views/pedido/Pedido.vue'),
    meta: {
      title: 'Syclus Pedidos - Pedido'
    }
  },
  // Configurações
  {
    path: '/configuracoes',
    name: 'Configuracoes',
    component: () => import('../views/Configuracoes.vue'),
    meta: {
      title: 'Syclus Pedidos - Configurações'
    }
  },
  // Clientes
  {
    path: '/clientes',
    name: 'Clientes',
    component: () => import('../views/cliente/Clientes.vue'),
    meta: {
      title: 'Syclus Pedidos - Clientes'
    }
  },
  {
    path: '/clientes/:id',
    name: 'Cliente',
    props: true,
    component: () => import('../views/cliente/Cliente.vue'),
    meta: {
      title: 'Syclus Pedidos - Cliente'
    }
  },
  // Produtos
  {
    path: '/produtos',
    name: 'Produtos',
    component: () => import('../views/Produtos.vue'),
    meta: {
      title: 'Syclus Pedidos - Produtos'
    }
  },
  // About
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to acces a restricted page
  const publicPages = ['/login']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = store.getters.isLoggedIn;

  if (authRequired && !loggedIn) {
    return next('/login')
  } else if (to.path == '/login' && loggedIn) {
    return next('/')
  }

  document.title = to.meta.title
  next()
})

export default router
